var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-group',{attrs:{"name":_vm.name,"label":_vm.label,"required":_vm.required,"inline":_vm.inline,"errors":_vm.errors}},[_c('div',{staticClass:"input-group"},_vm._l((_vm.options),function(option){return _c('ul',{key:option,staticClass:"icolors"},[_c('li',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(option),expression:"option"}],class:{
          [option]: option,
          active: _vm.values && _vm.values.includes(option)
        },attrs:{"name":_vm.name},on:{"click":function($event){return _vm.selectColor(option)}}})])}),0),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }